export default __webpack_public_path__ + "static/media/about-team-18.10bd5632.png";